module.exports = __webpack_public_path__ + "img/cash02.a974721c.png";